import React, { useEffect, useState } from 'react'
import dayjs from '@utils/dayjs'
import toCalendarDate from '@utils/toCalendarDate'
import Calendar from 'react-calendar'
import { useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  itemName: string
  index: number
  minDate?: dayjs.Dayjs
  maxDate: dayjs.Dayjs
  onChange?: () => void
}

const HistoryDate: React.FC<Props> = ({ prefix, itemName, index, minDate, maxDate, onChange }) => {
  const { register, watch, setValue } = useFormContext()
  const dateName = `${prefix}.history_value.date.${index}`
  const unknownName = `${prefix}.history_value.unknown.${index}`
  const dateStr = watch(dateName)
  const unknown = watch(unknownName)
  const [date, setDate] = useState(() => toCalendarDate(dateStr || maxDate))
  const handleChange = () => {
    if (onChange) {
      onChange()
    }
  }
  useEffect(() => {
    setValue(dateName, dayjs(date).format('YYYY-MM-DD'))
    handleChange()
  }, [date])

  const dayjsDate = dayjs.tz(dayjs(date).format('YYYY-MM-DD'))
  if (dayjsDate.isAfter(maxDate)) {
    setDate(toCalendarDate(maxDate))
  }
  if (minDate && dayjsDate.isBefore(minDate)) {
    setDate(toCalendarDate(minDate))
  }

  const errorPrefix = `${itemName ? `${itemName}について、` : ''}`

  const handleChangeDate = (newDate) => {
    setDate(newDate)
  }

  return (
    <div className="row justify-content-center">
      <div className="col-auto">
        <div>
          <label className="border-0 zm-checkbox m-0 mb-2 w-100">
            <input
              ref={register()}
              type="checkbox"
              name={unknownName}
              className="d-none"
              onChange={handleChange}
            />
            <div className="zm-checkmark zm-checkmark-t2" />
            わからない
          </label>
        </div>
        <div>
          <div className={unknown ? 'zm-disable-calendar' : ''} />
          <Calendar
            value={date}
            minDate={minDate ? toCalendarDate(minDate) : undefined}
            maxDate={toCalendarDate(maxDate)}
            onChange={handleChangeDate}
            className="zm-calendar"
            formatDay={(_locale, d) => dayjs(d).format('D')}
          />
        </div>
        <input
          ref={register({
            required: !unknown && `${errorPrefix}日付を入力してください`,
          })}
          type="hidden"
          name={dateName}
        />
      </div>
    </div>
  )
}

export default HistoryDate
